<div class="breadcrumb-container">
    <ul class="breadcrumb">
        <li *ngFor="let breadcrumb of breadcrumbData">{{ breadcrumb }}</li>
    </ul>
</div>
